// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__TbKNP","info":"PatientInfo_info__2rJ_1"};